import {useEffect, useState} from "react";
import {BondHead, bondRowFormatting} from "../../../../helpers/utils/OrderDetailUtils";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import JurisdictionListModal from "../Modals/JurisdictionListModal";

interface BondSectionProps {
    curAccount: any;
    certificate: any;
    setCertificate: React.Dispatch<React.SetStateAction<any>>;
    index: number;
    setShowAccount: React.Dispatch<React.SetStateAction<number>>;
    setIsSavedResult: React.Dispatch<React.SetStateAction<boolean>>;
    showAccount: number;
    editable: boolean;
    county: string;
    setUpdatedAccountIndexList: any;
}

export function BondSection({
                                certificate,
                                setCertificate,
                                index,
                                setShowAccount,
                                setIsSavedResult,
                                showAccount,
                                editable,
                                county,
                                setUpdatedAccountIndexList,
                            }: BondSectionProps) {
    const [removeBond, setRemoveBond] = useState(false);
    const [clearBondRow, setClearBondRow] = useState(false);
    const [addedNewBond, setAddedNewBond] = useState(false);
    const [showBondJurisdictionModal, setShowBondJurisdictionModal] = useState(false);
    const [bondId, setBondId] = useState(0);
    const [type, setType] = useState("");
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [msg, setMsg] = useState("");

    const account = certificate.accounts?.[showAccount];

    useEffect(() => {
        if (removeBond || clearBondRow || addedNewBond || bondId) {
            setUpdatedAccountIndexList((prevList:any) => {
                // Avoid duplicates
                if (!prevList.includes(showAccount)) {
                    return [...prevList, showAccount];
                }
                return prevList;
            });
            setIsSavedResult(false);
        }
    }, [removeBond, clearBondRow, addedNewBond, bondId]);



    useEffect(() => {
        if (removeBond && certificate) {
            setCertificate((prevCertificate: any) => {
                const updatedCertificate = {...prevCertificate};
                const bonds = updatedCertificate.accounts[showAccount].bondList;

                if (bonds.length === 1) {
                    updatedCertificate.accounts[showAccount].bondList = [{
                        jurisdictionName: "",
                        jurisdictionId: "",
                        bondsApproved: null,
                        bondsIssued: null,
                        standbyFee: null,
                    }];
                } else {
                    updatedCertificate.accounts[showAccount].bondList = bonds.filter((_: any, p: number) => p !== bondId);
                }

                return updatedCertificate;
            });
            setRemoveBond(false);
        }
    }, [removeBond, certificate, showAccount, bondId]);


    useEffect(() => {
        if (clearBondRow && certificate) {
            setCertificate((prevCertificate: any) => {
                const updatedCertificate = {...prevCertificate};
                const bond = updatedCertificate.accounts[showAccount].bondList[bondId];

                bond.jurisdictionName = "";
                bond.jurisdictionId = "";
                bond.collectorId = "";
                bond.collectorName = "";
                bond.bondsApproved = null;
                bond.bondsIssued = null;
                bond.standbyFee = null;

                return updatedCertificate;
            });
            setClearBondRow(false);
        }
    }, [clearBondRow, certificate, showAccount, bondId]);


    useEffect(() => {
        if (addedNewBond && certificate) {
            const account = certificate.accounts[showAccount]; // Access the correct account from certificate

            const tempPer = account?.bondList?.some((el: any) => el.collectorId === '' || el.jurisdictionName === '');

            if (!tempPer) {
                setCertificate((prevCert: any) => {
                    const updated = {...prevCert};
                    updated.accounts[showAccount].bondList = [
                        ...updated.accounts[showAccount].bondList,
                        {
                            jurisdictionName: "",
                            jurisdictionId: "",
                            bondsApproved: null,
                            bondsIssued: null,
                            standbyFee: null,
                        },
                    ];
                    return updated;
                });
            } else {
                setMsg("Jurisdiction name is required in Bond Information");
                setShowConfirmation(true);
            }

            setAddedNewBond(false);
        }
    }, [addedNewBond, certificate, showAccount]);


    return (
        <>
            <div className="col-lg-12 col-sm-12 mt-3 border border-highlight-3">
                <div className="border border-highlight-3 bg-highlight-5 py-2 text-text-0 pl-2">
                    <b>Bond Information</b>
                </div>
                <div>
                    <table className="w-full">
                        {BondHead(setAddedNewBond, editable)}
                        <tbody>
                        {account?.bondList?.map((row: any, t: number) => (
                            <tr className={"border-b border-surface-5"} key={t}>
                                <td className="text-center">
                                    <i
                                        onClick={() => {
                                            if (editable) {
                                                setBondId(t);
                                                setRemoveBond(true);
                                            }
                                        }}
                                        className="fa fa-icon-color fa-trash text-highlight-0"
                                        title="Delete Bond"
                                    />
                                </td>

                                <td className="position-relative">
                                    <div className="relative">
                                         <span
                                             title={row['jurisdictionName'] || undefined}
                                             className={`bg-text-0 radius-md p-3 text-surface-0 w-full block form-control ${!row['jurisdictionName'] ? 'text-muted' : ''}`}
                                         >
                                            {row['jurisdictionName'] || "Select Juris ..."}
                                        </span>

                                        {!row['jurisdictionName'] && (
                                            <span
                                                onClick={() => {
                                                    if (editable) {
                                                        setBondId(t);
                                                        setType("bond");
                                                        setShowBondJurisdictionModal(true);
                                                        setShowAccount(index);
                                                    }
                                                }}
                                                className="fa fa-search ml-xl-n4  text-highlight-5 top-[12px]  right-[15px] absolute"
                                            />
                                        )}

                                        {row['jurisdictionName'] && (
                                            <span
                                                onClick={() => {
                                                    if (editable) {
                                                        setBondId(t);
                                                        setClearBondRow(true);
                                                    }
                                                }}
                                                className="fa fa-times ml-xl-n4 collector-account-modal text-highlight-5 top-[12px]  right-[15px] absolute"
                                            />
                                        )}
                                    </div>
                                </td>

                                <td className="text-center">
                                    {bondRowFormatting(
                                        row,
                                        setCertificate,
                                        setBondId,
                                        t,
                                        certificate,
                                        'bondsApproved',
                                        setIsSavedResult,
                                        editable,
                                        showAccount,
                                        setUpdatedAccountIndexList
                                    )}
                                </td>

                                <td className="text-center">
                                    {bondRowFormatting(
                                        row,
                                        setCertificate,
                                        setBondId,
                                        t,
                                        certificate,
                                        'bondsIssued',
                                        setIsSavedResult,
                                        editable,
                                        showAccount,
                                        setUpdatedAccountIndexList
                                    )}
                                </td>

                                <td className="text-center">
                                    {bondRowFormatting(
                                        row,
                                        setCertificate,
                                        setBondId,
                                        t,
                                        certificate,
                                        'standbyFee',
                                        setIsSavedResult,
                                        editable,
                                        showAccount,
                                        setUpdatedAccountIndexList
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showBondJurisdictionModal && (
                <JurisdictionListModal
                    show={showBondJurisdictionModal}
                    setShow={setShowBondJurisdictionModal}
                    index={bondId}
                    certificate={certificate}
                    setCertificate={setCertificate}
                    showAccount={showAccount}
                    county={county}
                    type={type}
                    setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                    setIsSavedResult={setIsSavedResult}
                />
            )}

            {showConfirmation && (
                <ConfirmationModal
                    title="Alert"
                    bodyMessage={msg}
                    show={showConfirmation}
                    setShow={setShowConfirmation}
                />
            )}
        </>
    );
}
